import { DodonaElement } from "components/meta/dodona_element";
import { customElement, property } from "lit/decorators.js";
import { LlmResponse, llmResponseState } from "state/LlmResponse";
import { html, TemplateResult } from "lit";
import { i18n } from "i18n/i18n";

@customElement("d-draft-response-comment")
export class DraftResponseComment extends DodonaElement {
    @property({ type: Number, attribute: "llm-response-id" })
    llmResponseId: number | null;

    comment: string = "";

    get llmResponse(): LlmResponse {
        return llmResponseState.get(this.llmResponseId);
    }

    render(): TemplateResult {
        return this.llmResponse && (this.llmResponse.rating === "good" || this.llmResponse.rating === "bad")
            ? html`
                  <div class="comment-input flex-grow-1">
                      <input
                          required="required"
                          type="text"
                          class="form-control"
                          id="llm-response-comment"
                          placeholder=${i18n.t("js.annotation.draft.comment.placeholder")}
                          value=${this.llmResponse ? this.llmResponse.comment : ""}
                          @input="${(e: Event) => this.handleCommentInput(e)}"
                      />
                  </div>
              `
            : html``;
    }

    private handleCommentInput(e: Event): void {
        const target = e.target as HTMLTextAreaElement;
        this.llmResponse.comment = target.value;
    }
}
